<template>
  <div>
    <div class="head-box">
      <div class="c-flex c_flex_center">
        <h4>推广大使管理</h4>
      </div>
      <div class="c-flex c-flex-item">
        <el-input
          placeholder="请输入姓名/电话/地址"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <!-- <el-button type="primary" @click="doNew" class="c-m-l-10">新建推广大使</el-button> -->
        <el-button
          type="primary"
          class="c-m-l-10"
          @click="
            osg.doExport(
              {
                'fpi-regex:name|string#or': searchValue,
                'fpi-regex:phone|string#or': searchValue,
                'fpi-regex:otherPhone|string#or': searchValue,
                'fpi-regex:address|string#or': searchValue,
                'fpi-regex:_id|string#or': searchValue,
                beanName: 'promoter',
                title: '推广大使管理'
              },
              { dynamic: true }
            )
          "
        >
          数据导出
        </el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          highlight-current-row
          border
          @header-dragend="osg.colWidthChange"
        >
          <el-table-column fixed="right" width="100" label="操作">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="doEdit(scope.row)">
                    编辑
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state === 0"
                    @click.native="doEnable(scope.row)"
                  >
                    认证通过
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state === 1"
                    @click.native="doDisable(scope.row)"
                  >
                    取消认证
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="doRemove(scope.row)">
                    删除
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
          <c-table :fields="extFields"></c-table>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="新建推广大使" :visible.sync="openDetail">
      <c-form
        :formData="formData"
        :fields="extFields"
        :area="area"
        :upload="upload"
        :options="options"
        ref="form"
        labelWidth="150px"
        @changeForm="osg.changeForm"
      >
        <template slot="idcardFrontUrl">
          <el-upload
            v-model="formData.idcardFrontUrl"
            :action="upload.url"
            :data="upload.data"
            :file-list="formData.idcardFrontUrl"
            list-type="picture-card"
            :limit="upload.limit"
            :on-exceed="osg.uploadExceed"
            :before-upload="
              file => {
                return osg.beforeUpload(file, 'image');
              }
            "
            :on-success="
              (response, file, fileList) => {
                formData.idcardFrontUrl = upload.downloadUrl + response.key;
                idcardWithPerson(formData.idcardFrontUrl);
              }
            "
            :on-error="osg.uploadError"
            :before-remove="
              (file, fileList) => {
                return beforeRemove(file, fileList, 'fileList');
              }
            "
            :on-remove="
              (file, fileList) => {
                formData.idcardFrontUrl = '';
              }
            "
            :on-preview="osg.uploadPreview"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </template>
        <template slot="bankCardUrl">
          <el-upload
            v-model="formData.bankCardUrl"
            :action="upload.url"
            :data="upload.data"
            :file-list="formData.bankCardUrl"
            list-type="picture-card"
            :limit="upload.limit"
            :on-exceed="osg.uploadExceed"
            :before-upload="
              file => {
                return osg.beforeUpload(file, 'image');
              }
            "
            :on-success="
              (response, file, fileList) => {
                formData.bankCardUrl = upload.downloadUrl + response.key;
                bankcard(formData.bankCardUrl);
              }
            "
            :on-error="osg.uploadError"
            :before-remove="
              (file, fileList) => {
                return beforeRemove(file, fileList, 'fileList');
              }
            "
            :on-remove="
              (file, fileList) => {
                formData.bankCardUrl = '';
              }
            "
            :on-preview="osg.uploadPreview"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </template>
      </c-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'promoter',
  data() {
    window.$this = this;
    return {
      name: 'promoter',
      fpi: {},
      searchValue: '',
      openDetail: false,
      formData: {
        idcardFrontUrl: [], //身份证人像面识别
        bankCardUrl: [] //银行卡识别
      },
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      rules: this.$util.rules,
      options: {},
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      },
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false,
        limit: 1
      }
    };
  },
  mounted() {
    this.doInit();
    this.osg.getFields('promoter', () => {
      this.osg.getFpi();
      this.getData();
    });
  },
  methods: {
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      this.formData = { exts: {} };
      if (this.$refs.formData) this.$refs.formData.resetFields();
      this.$util.renderExtField(this.extFields, this.formData);
    },
    getData() {
      var params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 20,
        'regex:name|string#or': this.searchValue,
        'regex:phone|string#or': this.searchValue,
        'regex:address|string#or': this.searchValue,
        'nin:state|integer#and': -1
      };
      window.$that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('biz/promoter/query.do', params, res => {
        // console.log(res, '---res');
        // res.data.map(item => {
        //   item.idcardFrontUrl = JSON.parse(item.idcardFrontUrl);
        //   item.idcardBackUrl = JSON.parse(item.idcardBackUrl);
        //   item.bankCardUrl = JSON.parse(item.bankCardUrl);
        // });
        this.fpi = res;
        console.log(this.fpi, '-----fpi');
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
      this.$nextTick(() => {
        if (this.$refs.form && this.$refs.form.$refs.formData) {
          this.$refs.form.$refs.formData.clearValidate();
        }
      });
    },
    doSave() {
      if (this.osg.validate()) {
        this.$util.saveFormatExtField(this.extFields, this.formData);
        this.formData.idcardBackUrl = JSON.stringify(this.formData.idcardBackUrl);
        this.formData.idcardFrontUrl = JSON.stringify(this.formData.idcardFrontUrl);
        this.formData.bankCardUrl = JSON.stringify(this.formData.bankCardUrl);
        console.log(this.formData, '--this.formData');
        this.osg.ajax('biz/promoter/upsert.do', { data: JSON.stringify(this.formData) }, () => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    doEdit(row) {
      row = this.$util.deepCopy(row);
      this.$util.renderExtField(this.extFields, row);
      row.level = JSON.stringify(row.level);
      row.shareDirection = JSON.stringify(row.shareDirection);
      if (this.$util.isJson(row.idcardFrontUrl)) {
        row.idcardFrontUrl = JSON.parse(row.idcardFrontUrl);
      }
      if (this.$util.isJson(row.idcardBackUrl)) {
        row.idcardBackUrl = JSON.parse(row.idcardBackUrl);
      }
      if (this.$util.isJson(row.bankCardUrl)) {
        row.bankCardUrl = JSON.parse(row.bankCardUrl);
      }
      this.formData = row;
      this.openDetail = true;
    },
    doEnable(row) {
      this.osg.confirm(`是否确认认证通过“${row.name}”？`, () => {
        this.osg.ajax('biz/promoter/enable.do', { id: row._id }, () => {
          this.osg.toast('操作成功！');
          this.getData();
        });
      });
    },
    doDisable(row) {
      this.osg.confirm(`是否确认取消认证“${row.name}”？`, () => {
        this.osg.ajax('biz/promoter/disable.do', { id: row._id }, () => {
          this.osg.toast('操作成功！');
          this.getData();
        });
      });
    },
    doRemove(row) {
      this.osg.confirm(`是否确认删除“${row.name}”？`, () => {
        this.osg.ajax('biz/promoter/delete.do', { id: row._id }, () => {
          this.osg.toast('操作成功！');
          this.getData();
        });
      });
    },
    // 身份证国徽面识别
    idcardWithPerson(url) {
      this.osg.ajax('wmt/basic/ocr/idcardWithPerson', { url }, res => {
        this.formData.address = res.data.address;
        // this.formData.birthday = res.data.birthday;
        this.formData.idcardNo = res.data.idcardNo;
        // this.formData.nationality = res.data.nationality;
        this.formData.name = res.data.realName;
        this.formData.sex = res.data.sex;
        this.$forceUpdate();
      });
    },
    // 银行卡识别
    bankcard(url) {
      this.osg.ajax('wmt/basic/ocr/bankcard', { url }, res => {
        this.formData.bankCardNum = res.data.bankCardNum;
        // this.formData.bankCardType = res.data.bankCardType;
        // this.formData.bankCardTypeStr = res.data.bankCardTypeStr;
        this.formData.bankName = res.data.bankName;
        // this.formData.bankcardExpiringDate = res.data.expiringDate;
        this.$forceUpdate();
      });
    },
    beforeRemove(file, fileList, field) {
      let status = true;
      if (file && file.status === 'success') {
        status = this.$confirm('确定删除？');
      }
      return status;
    }
  }
};
</script>
